import type { IEntitySelectItem } from '~/types/models'

export function SupplierAndTsdDescr({
  supplier,
  tsd,
}: {
  supplier: IEntitySelectItem | undefined
  tsd: IEntitySelectItem | undefined
}): string | undefined {
  if (!supplier || !supplier.label) {
    return undefined
  }
  const supplierAndTsdDescr =
    !tsd || !tsd.label ? supplier.label : supplier.label + '\n' + tsd.label

  return supplierAndTsdDescr
}
